import { OAuthRedirect } from './OAuthRedirect';

export const CanvasOAuthRedirect = () => {
  return <OAuthRedirect provider="Canvas" />;
};
